import React, {FC} from 'react'
import { useQuery } from 'react-query'
import { getDetailProduct } from '../../../../modules/services/product.service'

interface Props {
  id? : string

}

const PersonalInfo: React.FC<Props> = ({id}) => {
  const {data, isLoading} = useQuery(['getProductDetail', id], async () => await getDetailProduct(id))
  const head = [
    {
      key : 'SKU',
      value:  `${data?.attributes.sku}`
    },
    {
      key :  'Product Packages',
      value: `${data?.attributes.name}`
    },
    {
      key : 'Detail Product',
      value: `${data?.attributes.product_detail}`
    },
    {
      key : 'Price',
      value: `${data?.attributes.transaction_value}`
    },
    {
      key : 'Desctiption',
      value: `${data?.attributes.description}`
    },
    {
      key : 'Link',
      value: `${data?.attributes.url}`
    },
    {
      key : 'Image',
      value: `${data?.attributes.image.data[0].attributes.formats.thumbnail.url}`
    },
  ]

  return (
    <div className='card-body p-9'>
      {!isLoading && 
        <div className='col d-flex flex-column gap-4'>
          {head.map((e) => (
            <div className='row mb-7'>
              <h4 className='col-lg-4 fw-bold text-muted fs-6'>{e.key}</h4>
              {
                !isLoading &&   <div className='col-lg-8'>
          
                {e.key === 'Image' ? <img  src={`${process.env.REACT_APP_IMAGE}${e.value}`}   /> :  <p className='fs-6 ms-8'>{e.value}</p> } 
              
               </div>
              }
            
            </div>
          ))}
        </div>
      }
      
    </div>
  )
}

export default PersonalInfo
